import { BACKEND_URI } from "../entries";
import { devLog } from "../utils/loggerUtils";
import { secureAPICall } from "../utils/sessionUtils";


export const requestTicketTemp = async ({ ticketId, ticketEmail, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId);
    formData.append("email", ticketEmail);

    const response = await fetch(BACKEND_URI + "/api/tickets/search-ticket-temporary", {
        method: "POST",
        body: formData,
        mode: "cors",
        credentials: "include"
    })
    const result = await response.json();
    if (!response.ok) {
        throw {
            status: response.status,
            message: result.detail
        }
    }
    else {
        if (verbose) {
            devLog(result.status, result.message)
            devLog(result)
        }
        return result.data
    }
}


export const requestFetchTicketsByTimestamp = async ({ timestamp, verbose = false }) => {
    const formData = new FormData()
    formData.append("createdAt", timestamp)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/fetch-tickets-by-timestamp", body: formData, verbose: verbose })
}


export const requestTicket = async ({ ticketId, ticketEmail, ticketNumber, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId);
    formData.append("email", ticketEmail ?? null);
    formData.append("createdAt", ticketNumber ?? 0)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/fetch-ticket", body: formData, verbose: verbose })
}


export const requestTicketSubmit = async ({ name, email, category, server, characterName, violatersName, subject, description, files, language, captchaToken, verbose = false }) => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("category", category);
    formData.append("server", server);
    formData.append("characterName", characterName);
    formData.append("violatersName", violatersName);
    formData.append("subject", subject);
    formData.append("description", description);
    formData.append("language", language);
    formData.append("captchaToken", captchaToken)

    for (let i = 0; i < files.length; i++) {
        formData.append("files", files[i]);
    }

    const response = await fetch(BACKEND_URI + "/api/tickets/submit", {
        method: "POST",
        body: formData,
        mode: "cors"
    })
    const result = await response.json();
    if (!response.ok) {
        console.error("error occured")
        throw {
            status: "WARNING",
            message: result.detail
        }
    }
    if (verbose) {
        devLog(result.status, result.message)
        devLog(result)
    }
    return result
}


export const requestEditTicket = async ({ ticketId, editedCategory, editedPriority, verbose = false }) => {
    const formData = new FormData();
    formData.append("ticket_id", ticketId)
    formData.append("new_category", editedCategory)
    formData.append("new_priority", editedPriority)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/update-ticket", body: formData, verbose: verbose })
}


export const requestAssignDev = async ({ selectedDevId, ticketId, selectedCategory, server, prevDevId, chatId, random, verbose = false }) => {
    const formData = new FormData();
    if (!random) {
        formData.append("devId", selectedDevId)
    }
    formData.append("ticketId", ticketId)
    formData.append("category", selectedCategory)
    formData.append("server", server)
    formData.append("prevDevId", prevDevId)
    formData.append("chatId", chatId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/assign-ticket", body: formData, verbose: verbose })
}


export const requestSubmitCompleteTicket = async ({ ticketInfo, action, excuse, isUnAnswered, verbose = false }) => {
    const formData = new FormData();
    formData.append("ticket_id", ticketInfo.id)
    formData.append("action", action)
    formData.append("unanswered", isUnAnswered)
    formData.append("excuse", excuse)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/submit-ticket-complete", body: formData, verbose: verbose })
}


export const requestMemberSubmitCompleteTicket = async ({ ticketId, verbose = false }) => {
    const formData = new FormData();
    formData.append("ticket_id", ticketId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/submit-ticket-complete-member", body: formData, verbose: verbose })
}


export const requestReopenTicket = async ({ ticketInfo, lastUserClass, verbose = false }) => {
    const formData = new FormData();
    formData.append("ticket_id", ticketInfo.id)
    formData.append("last_user_class", lastUserClass)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/reopen-ticket", body: formData, verbose: verbose })
}


export const requestSearchTickets = async ({ ticketId, ticketIdMode, name, nameMode, email, emailMode, characterName, characterNameMode, selectedServer, selectedCategory, selectedStatus, selectedPriority, selectedDeveloper, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    formData.append("ticket_id_mode", ticketIdMode)
    formData.append("name", name)
    formData.append("name_mode", nameMode)
    formData.append("email", email)
    formData.append("email_mode", emailMode)
    formData.append("character_name", characterName)
    formData.append("character_name_mode", characterNameMode)
    formData.append("server", selectedServer)
    formData.append("category", selectedCategory)
    formData.append("status", selectedStatus)
    formData.append("priority", selectedPriority)
    formData.append("employee", selectedDeveloper)

    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/search-tickets", body: formData, verbose: verbose })
}


export const requestPaginationSearchTickets = async ({ isDefault, ticketId, ticketIdMode, name, nameMode, email, emailMode, characterName, characterNameMode, selectedServer, selectedCategory, selectedStatus, selectedPriority, selectedDeveloper, currentPage, entriesPerPage, sortByIndex, order, tagged, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    formData.append("ticket_id_mode", ticketIdMode)
    formData.append("name", name)
    formData.append("name_mode", nameMode)
    formData.append("email", email)
    formData.append("email_mode", emailMode)
    formData.append("character_name", characterName)
    formData.append("character_name_mode", characterNameMode)
    formData.append("server", selectedServer)
    formData.append("category", selectedCategory)
    formData.append("status", selectedStatus)
    formData.append("priority", selectedPriority)
    formData.append("employee", selectedDeveloper)

    formData.append("page", currentPage)
    formData.append("entries_per_page", entriesPerPage)
    formData.append("sort_by", sortByIndex)
    formData.append("order", order)

    formData.append("default", isDefault)
    formData.append("tagged", tagged)

    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/pagination-search-tickets", body: formData, verbose: verbose })
}


export const requestAdvancedSearchTickets = async ({ ticketId, ticketIdMode, name, nameMode, email, emailMode, characterName, characterNameMode, selectedServer, selectedCategory, selectedStatus, selectedPriority, selectedDeveloper, currentPage, entriesPerPage, sortByIndex, order, subject, description, chatMessage, createdAt, lastUpdated, tagged, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    formData.append("ticket_id_mode", ticketIdMode)
    formData.append("name", name)
    formData.append("name_mode", nameMode)
    formData.append("email", email)
    formData.append("email_mode", emailMode)
    formData.append("character_name", characterName)
    formData.append("character_name_mode", characterNameMode)
    formData.append("server", selectedServer)
    formData.append("category", selectedCategory)
    formData.append("status", selectedStatus)
    formData.append("priority", selectedPriority)
    formData.append("employee", selectedDeveloper)

    formData.append("subject", subject)
    formData.append("description", description)
    formData.append("chatMessage", chatMessage)
    formData.append("createdAt", createdAt)
    formData.append("lastUpdated", lastUpdated)

    formData.append("page", currentPage)
    formData.append("entries_per_page", entriesPerPage)
    formData.append("sort_by", sortByIndex)
    formData.append("order", order)
    formData.append("tagged", tagged)

    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/advanced-search-tickets", body: formData, verbose: verbose })
}


export const requestFastActionExcuses = async ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/fetch-fast-action-excuses", verbose: verbose })
}


export const requestBanTempUser = async ({ ticketId, banReason, banTime, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    formData.append("ban_reason", banReason)
    formData.append("ban_time", banTime)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/ban-temporary-user", body: formData, verbose: verbose })
}


export const requestBanMember = async ({ ticketId, banReason, banTime, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    formData.append("ban_reason", banReason)
    formData.append("ban_time", banTime)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/ban-member-user", body: formData, verbose: verbose })
}


export const requestUnbanTempUser = async ({ ticketId, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/unban-temporary-user", body: formData, verbose: verbose })
}


export const requestUnbanMember = async ({ ticketId, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/unban-member-user", body: formData, verbose: verbose })
}


export const requestPutTicketOnHold = async ({ ticketId, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/put-ticket-on-hold", body: formData, verbose: verbose })
}


export const requestBanHistoryTemp = async ({ email, verbose = false }) => {
    const formData = new FormData()
    formData.append("email", email)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/get-ban-history-temporary", body: formData, verbose: verbose })
}


export const requestBanHistoryMember = async ({ memberId, verbose = false }) => {
    const formData = new FormData()
    formData.append("member_id", memberId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/get-ban-history-member", body: formData, verbose: verbose })
}


export const requestTicketMemberSubmit = async ({ category, server, characterName, violatersName, subject, description, files, captchaToken, verbose = false }) => {
    const formData = new FormData();
    formData.append("category", category);
    formData.append("server", server);
    formData.append("characterName", characterName);
    formData.append("violatersName", violatersName);
    formData.append("subject", subject);
    formData.append("description", description);
    formData.append("captchaToken", captchaToken)
    for (let i = 0; i < files.length; i++) {
        formData.append("files", files[i]);
    }
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/submit-member-ticket", body: formData, verbose: verbose })
}


export const requestTicketMemberHistory = async ({ verbose: verbose }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/member-ticket-history", verbose: verbose })
}


export const requestTicketMember = async ({ ticketId, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/fetch-member-ticket", body: formData, verbose: verbose })
}


export const requestSetRetainAttachments = async ({ ticketId, isRetain, verbose = false }) => {
    const formData = new FormData()
    formData.append("ticket_id", ticketId)
    formData.append("is_retain", isRetain)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/set-retain-attachments", body: formData, verbose: verbose })
}


export const requestFetchTicketsLast5 = ({ userId, verbose = false }) => {
    const formData = new FormData()
    formData.append("user_id", userId)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/tickets/fetch-tickets-last5", body: formData, verbose: verbose })
}